import { render, staticRenderFns } from "./SectionTeamMember.vue?vue&type=template&id=6c4108d8&scoped=true"
import script from "./SectionTeamMember.vue?vue&type=script&lang=ts"
export * from "./SectionTeamMember.vue?vue&type=script&lang=ts"
import style0 from "./SectionTeamMember.vue?vue&type=style&index=0&id=6c4108d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4108d8",
  null
  
)

export default component.exports